/* ============
 * Mutations for the app module
 * ============
 *
 * The mutations that are available on the
 * app module.
 */

import {
  SECTION
} from './mutation-types'

export default {
  [SECTION] (state, section) {
    state.section = section
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/app/mutations.js